import { createAction } from '@reduxjs/toolkit';
import type { chartOfAccountsTypes } from 'app-components/flux/chart-of-accounts';
import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';
import type { AxiosResponse } from 'axios';

import type { Category, CategoryProps } from './categoriesTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const syncCategoryPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<CategoryProps>>();
const categoryPayloadCreator = getPayloadCreator<Category>();
const categoriesPayloadCreator = getPayloadCreator<Category[]>();
type DeleteAndReassignCategoryPayload = {
  id: string;
  coa: chartOfAccountsTypes.ChartOfAccountProps;
};
const deleteAndReassignCategoryPayloadCreator = getPayloadCreator<DeleteAndReassignCategoryPayload>();

export const getCategories = createAction('GET_CATEGORIES', getPayloadCreator());
export const getCategoriesSuccess = createAction('GET_CATEGORIES_SUCCESS', syncCategoryPayloadCreator);
export const getCategoriesFailure = createAction('GET_CATEGORIES_FAILURE', errorPayloadCreator);

export const createCategory = createAction('CREATE_CATEGORY', categoryPayloadCreator);
export const createCategorySuccess = createAction('CREATE_CATEGORY_SUCCESS', categoryPayloadCreator);
export const createCategoryFailure = createAction('CREATE_CATEGORY_FAILURE', errorPayloadCreator);

export const updateCategory = createAction('UPDATE_CATEGORY', categoryPayloadCreator);
export const updateCategorySuccess = createAction('UPDATE_CATEGORY_SUCCESS', categoryPayloadCreator);
export const updateCategoryFailure = createAction('UPDATE_CATEGORY_FAILURE', errorPayloadCreator);

export const deleteCategory = createAction('DELETE_CATEGORY', categoryPayloadCreator);
export const deleteCategorySuccess = createAction('DELETE_CATEGORY_SUCCESS', categoryPayloadCreator);
export const deleteCategoryFailure = createAction('DELETE_CATEGORY_FAILURE', errorPayloadCreator);

export const batchCategories = createAction('BATCH_CATEGORIES', categoriesPayloadCreator);
export const batchCategoriesSuccess = createAction('BATCH_CATEGORIES_SUCCESS', categoriesPayloadCreator);
export const batchCategoriesFailure = createAction('BATCH_CATEGORIES_FAILURE', categoriesPayloadCreator);

export const initCategories = createAction('INIT_CATEGORIES', categoryPayloadCreator);
export const initCategoriesSuccess = createAction('INIT_CATEGORIES_SUCCESS', categoryPayloadCreator);
export const initCategoriesFailure = createAction('INIT_CATEGORIES_FAILURE', errorPayloadCreator);

export const deleteAndReassignCategory = createAction(
  'DELETE_AND_REASSIGN_CATEGORY',
  deleteAndReassignCategoryPayloadCreator,
);
export const deleteAndReassignCategorySuccess = createAction(
  'DELETE_AND_REASSIGN_CATEGORY_SUCCESS',
  getPayloadCreator<AxiosResponse>(),
);
export const deleteAndReassignCategoryFailure = createAction(
  'DELETE_AND_REASSIGN_CATEGORY_FAILURE',
  getPayloadCreator<any>(),
);
